import React from "react";
import RevealOnScroll from "./RevealOnScroll";

const MainProduct = () => {
  return (
    <section id="leistungen" className="section-spacing bg-white relative overflow-hidden">
      {/* Decorative background */}
      <div className="absolute top-20 right-0 w-96 h-96 bg-[#4a9da8]/5 rounded-full blur-3xl"></div>

      <div className="container-custom relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-10 md:gap-12 items-start md:items-center">
            {/* Left side - Gründerprofil */}
            <RevealOnScroll variant="fade-left" delay={0}>
              <div className="relative">
                <div className="aspect-[4/5] rounded-3xl overflow-hidden border-2 border-[#e8e4dc] bg-[#f5f5f5]">
                  <img
                    src={process.env.PUBLIC_URL + "/JakobUeberUns.jpg"}
                    alt="Jakob Dietmar Riegler, Gründer von Marmoris Studio"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                {/* Floating badge */}
                <div className="absolute -top-4 -right-4 bg-gradient-to-r from-[#2c4a52] to-[#4a9da8] px-6 py-3 rounded-full shadow-xl">
                  <p className="text-white font-bold">360° Betreuung</p>
                </div>
                <div className="mt-4 p-5 bg-[#f5f5f5] rounded-2xl border border-[#e8e4dc]">
                  <h3 className="text-lg font-bold text-[#0f1419]">Jakob Dietmar Riegler</h3>
                  <p className="text-[#3a3a3a]/80 text-sm">Gründer von Marmoris Studio</p>
                </div>
              </div>
            </RevealOnScroll>

            {/* Right side - Über uns */}
            <RevealOnScroll variant="fade-right" delay={0}>
              <RevealOnScroll
                as="div"
                variant="fade-up"
                delay={40}
                className="inline-block px-4 py-2 bg-[#4a9da8]/10 text-[#4a9da8] text-sm font-semibold rounded-full mb-6"
              >
                Über uns
              </RevealOnScroll>

              <RevealOnScroll
                as="h2"
                variant="fade-up"
                delay={80}
                className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#0f1419] mb-6 leading-tight break-words"
              >
                Professionelle 360° Betreuung
                <br />
                <span className="gradient-text">für Social Media</span>
              </RevealOnScroll>

              <RevealOnScroll as="div" variant="fade-up" delay={120} className="space-y-5">
                <p className="text-lg text-[#3a3a3a] leading-relaxed">
                  Wir bieten professionelle 360° Social-Media-Betreuung für Unternehmen, die online sichtbar wachsen und ihre Zielgruppe gezielt erreichen möchten. Dabei gehen wir individuell auf jedes Unternehmen ein, analysieren Ziele, Werte und Zielgruppe und entwickeln eine Strategie, die genau dazu passt.
                </p>
                <p className="text-lg text-[#3a3a3a] leading-relaxed">
                  Da wir bereits mit Unternehmen aus verschiedenen Branchen zusammenarbeiten, sind wir breit aufgestellt und bringen vielseitige Erfahrung mit. Dadurch verstehen wir unterschiedliche Märkte, Zielgruppen und Anforderungen und können Social-Media-Konzepte entwickeln, die individuell, authentisch und wirkungsvoll sind.
                </p>
                <p className="text-lg text-[#3a3a3a] leading-relaxed">
                  Von der Content-Planung und Erstellung über Posting, Community-Management und Analyse bis hin zur laufenden Optimierung übernehmen wir die ganzheitliche Betreuung Ihres Social-Media-Auftritts.
                </p>

                <div className="accent-line p-5 bg-[#f5f5f5] rounded-2xl">
                  <p className="text-sm md:text-base text-[#3a3a3a]/80 leading-relaxed">
                    Content-Planung · Content-Erstellung · Posting · Community-Management · Analyse · Laufende Optimierung
                  </p>
                </div>
              </RevealOnScroll>
            </RevealOnScroll>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MainProduct;
